<template>
  <div>
    <div style="background: #00953b">
      <v-container>
        <v-row class="white--text">
          <v-col>
            <p style="font-size: 18pt">Contáctenos</p>
            <p>
              Sede Principal: <br />
              Tel: +57 2 4450000<br />
              Km 17 Recta Cali-Palmira CP 763537 Apartado Aéreo 6713, Cali,
              Colombia
            </p>
            <p>
              <a
                class="white--text"
                href="https://ciat.cgiar.org/en-donde-trabajamos/?lang=es"
                >Contáctese con nuestras oficinas regionales y alrededor del
                mundo</a
              >
            </p>
          </v-col>
          <v-col>
            <div class="d-flex flex-column justify-space-between align-center">
              <v-img
                class="mb-3"
                src="https://ciat.cgiar.org/wp-content/uploads/2016/09/cgiar-logo200-white.png"
                width="150"
              ></v-img>
              <p>Un Centro de Investigación de CGIAR</p>
            </div>
          </v-col>
          <v-col>
            <div class="d-flex flex-column justify-space-between align-center">
              <v-img
                class="mb-3"
                src="https://ciat.cgiar.org/wp-content/uploads/Alianza_logos-ESPA%C3%91OL-04.png"
                width="300"
              ></v-img>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div style="background: #cc3333">
      <v-container class="py-0">
        <v-row>
          <v-col>
            <div style="display: flex; align-items: center">
              <p class="mb-0 white--text">
                Copyright © 2020 International Center for Tropical Agriculture -
                CIAT
              </p>

              <v-spacer></v-spacer>

              <v-btn
                v-for="link in links"
                :key="link.icon"
                class="mx-4"
                dark
                icon
                target="_blank"
                :href="link.url"
              >
                <v-icon size="24px">
                  {{ link.icon }}
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterCiat",
  data: () => ({
    links: [
      {
        icon: "mdi-facebook",
        url: "https://www.facebook.com/BiovIntCIAT.eng/",
      },
      {
        icon: "mdi-twitter",
        url: "https://twitter.com/BiovIntCIAT_eng",
      },
      {
        icon: "mdi-youtube",
        url: "https://www.youtube.com/user/ciatwebg",
      },
      {
        icon: "mdi-linkedin",
        url: "https://www.linkedin.com/organization-guest/company/ciat",
      },
      {
        icon: "mdi-instagram",
        url: "https://www.instagram.com/bioversityciat/",
      },
    ],
  }),
};
</script>
